import AgenciaDelete from './AgenciaDelete'
export {AgenciaDelete}
export default AgenciaDelete
